import { BaseController } from '../../../../../common/base/controller';

export class SuccessfulConfirmController extends BaseController {
  constructor(controllerService, transferringService, ticketStateName, uploadWarrantStateName) {
    'ngInject';
    super({ controllerService, transferringService, ticketStateName, uploadWarrantStateName });
  }

  $onInit() {
    this.breadcrumbs = this.transferringService.states;
  }

  navigateToTicket() {
    const { ticketStateName, ticket } = this;
    this.go(ticketStateName, { ticketId: ticket.id });
  }

  navigateToUpload() {
    this.go(this.uploadWarrantStateName);
  }
}
